module.exports = __webpack_public_path__ + "files/pulcini.303d4282939b1bfab2cc2ab947870c4f.pdf";